import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = memuat, false = belum login

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    // Confirm the browser kept the session cookie before showing any page. Browsers that block
    // cross-site cookies (Safari/iOS) drop it silently, which used to flash the dashboard and bounce back.
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      if (e.response?.status === 401) {
        const blocked = new Error(
          "Login berhasil, tetapi browser tidak menyimpan sesi. Nonaktifkan pemblokiran cookie untuk situs ini, atau hubungi Super Admin."
        );
        blocked.sessionBlocked = true;
        throw blocked;
      }
      throw e;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // abaikan
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
